module.exports = __webpack_public_path__ + "static/img/avatar-border.95dbba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happyBirthday/avatar-border.png
// module id = UnSo
// module chunks = 1